import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {PropType} from "vue";
import {VASelectCascadeOptions} from "typings";
import VASelect from "../VASelect/VASelect"
import {useSelectCascadeHandler} from "./hooks";


export default /*@__PURE__*/_defineComponent({
  __name: 'VASelectCascade',
  props: {
  // 绑定的值
  value: {
    type: Object as PropType<string | number | boolean>,
    required: true
  },
  options: {
    type: Object as PropType<VASelectCascadeOptions>,
    required: true,
    default: () => {
      return {}
    }
  },
  placeholder: {
    type: String
  },
  disabled: {
    type: Boolean,
    default: false
  },
  width: {
    type: String,
    default: "100%"
  },
  size: {
    type: String
  },
},
  emits: ["update:value", "change"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const props = __props

const {
  parentValue, child, childRef, changeParent
} = useSelectCascadeHandler(props.options as VASelectCascadeOptions, emit)

const change = (value: any) => {
  emit("update:value", value)
  emit("on-change", value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(VASelect), {
      value: _unref(parentValue),
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(parentValue) ? (parentValue).value = $event : null)),
      disabled: __props.disabled,
      options: __props.options,
      width: __props.width || '48%',
      placeholder: __props.placeholder,
      onChange: _unref(changeParent),
      size: __props.size
    }, null, 8, ["value", "disabled", "options", "width", "placeholder", "onChange", "size"]),
    _cache[1] || (_cache[1] = _createElementVNode("span", { style: {"margin":"0 5px"} }, "-", -1)),
    _createVNode(_unref(VASelect), {
      disabled: __props.disabled,
      ref_key: "childRef",
      ref: childRef,
      options: _unref(child),
      placeholder: _unref(child).placeholder,
      value: __props.value,
      width: _unref(child).width || '48%',
      onChange: change,
      field: _unref(child).field,
      size: __props.size
    }, null, 8, ["disabled", "options", "placeholder", "value", "width", "field", "size"])
  ], 64))
}
}

})